// filepath: /Users/avinash/Drop/df-website/src/app/services/environment.service.ts
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FacilityConfig, Link } from 'src/environments/environment.interface';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root', // Makes the service available application-wide
})
export class EnvironmentService {
  private _facilityConfig: FacilityConfig | null = null;

  constructor(private configService: ConfigService) {}

  get facilityConfig(): FacilityConfig {
    if (!this._facilityConfig) {
      this._facilityConfig = this.configService.getConfig();
    }
    return this._facilityConfig;
  }

  /**
   * Get the entire FacilityConfig object.
   */
  public getFacilityConfig(): FacilityConfig {
    return this.facilityConfig;
  }

  /**
   * Get a specific link url by its ID.
   * @param id The ID of the link to retrieve.
   */
  public getLinkUrlByName(id: string): string {
    const link = this.facilityConfig.links.find((link) => link.id === id);
    return link?.url ? link.url : '';
  }

  /**
   * Get a specific link by its ID.
   * @param id The ID of the link to retrieve.
   */
  public getLinkById(id: string): Link {
    const link = this.facilityConfig.links.find((link) => link.id === id);
    return link ? link : { id: '', name: '', url: '' }; // Default to an empty link object if not found
  }

  /**
   * Get a specific property from FacilityConfig.
   * @param key The key of the property to retrieve.
   */
  public getProperty<T extends keyof FacilityConfig>(key: T): FacilityConfig[T] {
    return this.facilityConfig[key];
  }
}